import React, { createContext, useContext } from 'react';
import { useUnlayerTemplatesEditor } from '../useUnlayerTemplatesEditor';

const UnlayerTemplatesEditorContext = createContext(null);

export const UnlayerTemplatesEditorProvider = ({ options, children }) => {
	const editor = useUnlayerTemplatesEditor(options);

	return (
		<UnlayerTemplatesEditorContext.Provider value={editor}>
			{children}
		</UnlayerTemplatesEditorContext.Provider>
	);
};

export const useUnlayerTemplatesEditorContext = () => {
	const context = useContext(UnlayerTemplatesEditorContext);

	if (!context) {
		throw new Error(
			'useUnlayerTemplatesEditorContext must be used within an UnlayerTemplatesEditorProvider.',
		);
	}

	return context;
};
